import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

interface StoreTypes {
    openFreeYatModal: boolean;
    setOpenFreeYatModal: (value: boolean) => void;
    openPrimaryYatModal: boolean;
    setOpenPrimaryYatModal: (value: boolean) => void;
    openPublicYatConfirmModal: boolean;
    setOpenPublicYatConfirmModal: (value: boolean) => void;
    selectedYat: string | undefined;
    setSelectedYat: (value: string | undefined) => void;
}

export const useProfileNotificationsStore = create<StoreTypes>()(
    devtools((set) => ({
        openFreeYatModal: false,
        setOpenFreeYatModal: (value) => set({ openFreeYatModal: value }),
        openPrimaryYatModal: false,
        setOpenPrimaryYatModal: (value) => set({ openPrimaryYatModal: value }),
        openPublicYatConfirmModal: false,
        setOpenPublicYatConfirmModal: (value) => set({ openPublicYatConfirmModal: value }),
        selectedYat: undefined,
        setSelectedYat: (value) => set({ selectedYat: value }),
    })),
);

interface WarningStoreTypes {
    dontShowPublicYatWarningModal: boolean;
    setDontShowPublicYatWarningModal: (value: boolean) => void;
}

export const useProfileWarningStore = create<WarningStoreTypes>()(
    devtools(
        persist(
            (set) => ({
                dontShowPublicYatWarningModal: false,
                setDontShowPublicYatWarningModal: (value) => set(() => ({ dontShowPublicYatWarningModal: value })),
            }),
            {
                name: 'profile-warning-storage',
            },
        ),
    ),
);
